import axios from "axios";

const runtimeBackend = typeof window !== "undefined" ? window.__BACKEND_URL__ : undefined;
const backendUrl = (runtimeBackend || process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");

const apiClient = axios.create({
  baseURL: backendUrl ? `${backendUrl}/api` : "/api",
  timeout: 15000,
  withCredentials: true,
});

export default apiClient;
